import reframe from 'nike-re-framejs';
import { defaultMiddlewares } from '@/common/util';
import { loadLegalInfoArticles } from './api';

reframe.registerHandler('legalInfoArticles.load', defaultMiddlewares, db => {
    if (!db.getIn(['cms', 'sections', 'legalInfo'])) {
        loadLegalInfoArticles();
    }
    return db;
});
